import type { Condition, Patient, Reference } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { LIST_TYPE } from '#src/codeSystems.ts'
import { ExtendedList } from '#src/models/list.ts'
import type { QueryTypes } from '#src/search.ts'

const CONDITION_ORDERING_CODE = 'condition-ordering'

export const conditionOrderingCode = codeableConcept({
  system: LIST_TYPE,
  code: CONDITION_ORDERING_CODE,
  display: 'Condition Ordering',
})

export class ConditionOrdering extends ExtendedList {
  static readonly CODE = CONDITION_ORDERING_CODE

  constructor(patient: Reference<Patient>) {
    super({
      title: 'Condition Ordering',
      subject: patient,
      code: conditionOrderingCode,
      orderedBy: {
        coding: [
          {
            system: 'http://hl7.org/fhir/list-order',
            code: 'user',
            display: 'Sorted by User',
          },
        ],
      },
    })
  }

  static byPatient(patient: Reference<Patient>): QueryTypes {
    return {
      subject: patient.reference,
      code: `${LIST_TYPE}|${CONDITION_ORDERING_CODE}`,
      status: 'current',
    }
  }

  get conditions(): Reference<Condition>[] {
    return (
      this.resource.entry?.map((entry) => entry.item as Reference<Condition>) ??
      []
    )
  }

  set conditions(conditions: Reference<Condition>[]) {
    if (conditions.length === 0) {
      this.resource.entry = []
      return
    }
    this.resource.entry = conditions.map((condition) => ({
      item: condition,
    }))
  }
}
